/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Adjustment,
    AdjustmentFromJSON,
    AdjustmentFromJSONTyped,
    AdjustmentToJSON,
    Page,
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './';

/**
 * 
 * @export
 * @interface ListAdjustmentsResponse
 */
export interface ListAdjustmentsResponse {
    /**
     * 
     * @type {Page}
     * @memberof ListAdjustmentsResponse
     */
    paging?: Page;
    /**
     * 
     * @type {Array<Adjustment>}
     * @memberof ListAdjustmentsResponse
     */
    data?: Array<Adjustment>;
}

export function ListAdjustmentsResponseFromJSON(json: any): ListAdjustmentsResponse {
    return ListAdjustmentsResponseFromJSONTyped(json, false);
}

export function ListAdjustmentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAdjustmentsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paging': !exists(json, 'paging') ? undefined : PageFromJSON(json['paging']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(AdjustmentFromJSON)),
    };
}

export function ListAdjustmentsResponseToJSON(value?: ListAdjustmentsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paging': PageToJSON(value.paging),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(AdjustmentToJSON)),
    };
}


